var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-do-server-action-button',{staticClass:"btn btn-primary",attrs:{"uri":_vm.getUrl,"do-save":_vm.doSave,"request":_vm.request,"variant-color":_vm.getVariant},on:{"success":_vm.success}},[_vm._v("\n  "+_vm._s(_vm.trigger.params.buttonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }